import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NetworkInfluencerTable = ({ networkList, selectedStartDate }) => {
  const navigate = useNavigate();
  const handleShowDetails = (network_id, beneficiary_esi_id) => {
    navigate('/benefits/network-influencer', {
      state: {
        network_id: network_id,
        selectedDate: selectedStartDate ? selectedStartDate : null,
        beneficiary_esi_id: beneficiary_esi_id
      },
    });
  };
  return (
    <TableContainer
      component={Paper}
      sx={{ overflowX: 'auto' }}
    >
      <Table>
        <TableHead>
          <TableRow
            sx={{
              background: '#f4f6f8',
              borderBottom: '1px dashed #919eab33',
            }}
          >
            <TableCell
              sx={{
                color: '#637381',
                fontWeight: 'bold',
                borderBottom: 'none',
              }}
            >
              Network Name
            </TableCell>
            <TableCell
              sx={{
                color: '#637381',
                fontWeight: 'bold',
                borderBottom: 'none',
              }}
            >
              Active Influencers
            </TableCell>
            <TableCell
              sx={{
                color: '#637381',
                fontWeight: 'bold',
                borderBottom: 'none',
              }}
            >
              Reward Announced
            </TableCell>
            <TableCell
              sx={{
                color: '#637381',
                fontWeight: 'bold',
                borderBottom: 'none',
              }}
            >
              Last Announced Date
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {networkList && networkList.length > 0 ? (
            networkList.map((gift, index) => {
              return (
                <TableRow
                  key={index}
                  sx={{
                    borderBottom: '1px dashed #919eab33',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleShowDetails(gift.id, gift.beneficiary_esi_id)}
                >
                  <TableCell sx={{ borderBottom: 'none', fontWeight: 'bold' }}>
                    {gift.beneficiary_name}
                    <Box sx={{ display: 'flex', mt: 0.5 }}>
                      {gift.beneficiary_phone && (
                        <Typography
                          variant='caption'
                          sx={{ mr: 1 }}
                        >
                          Phone - {gift?.beneficiary_phone}
                        </Typography>
                      )}
                      {gift.beneficiary_phone && gift.beneficiary_role && (
                        <Typography
                          variant='caption'
                          sx={{ mx: 1 }}
                        >
                          |
                        </Typography>
                      )}
                      {gift.beneficiary_role && (
                        <Typography variant='caption'>
                          Role - {gift?.beneficiary_role}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'none' }}>
                    {gift.active_influencer || '-'}
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'none' }}>
                    {gift.reward_announced || '-'}
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'none' }}>
                    {gift.last_announced || '-'}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow sx={{ borderBottom: '1px dashed #919eab33' }}>
              <TableCell
                colSpan={6}
                align='center'
              >
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NetworkInfluencerTable;
